export const PAPER_SIZES: {name: string}[] = [
    {name: 'A4'}, {name: 'A5'}, {name: 'A3'}
];
